<template>
  <module-configuration :data="config" :errors="errors" :useAuthentication="false">
    <modal-service v-model="modalServiceFlag" :terms="config.serviceTerms" v-on:confirm="modalService()"/>
    <panel title="Termos de Uso">
      <div class="l-row">
        <form-group>
          <div v-if="!config.serviceTerms.user || !config.serviceTerms.date">
            <label>
              <input type="checkbox" v-model="config.serviceTerms.accepted">
              Declaro ter lido e aceitado os
            </label>
            <a
              data-label="Visualizar Termos e Politicas de Serviço"
              @click="modalServiceFlag = true"
              class="terms-link"
            >
              Termos e Politicas de Serviço
            </a>.
            <small class="form-help">É necessário aceitar os Termos e Politicas de Serviços para ativação e utilização da integração Amazon com PlaceMarket.</small>
          </div>

          <div v-else>
            <a
              data-label="Visualizar Termos e Politicas de Serviço"
              @click="modalServiceFlag = true"
              class="terms-link"
            >
              Termos e Politicas de Serviço 
            </a>
            <p class="inline-text">
              já aceitos. 
            </p>
          </div>
        </form-group>
      </div>
    </panel>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('order.label')">
      <div class="l-row">
        <form-group label="Tempo (em dias) para resgate de pedidos">
          <input class="form-input" min="1" type="number" v-model="config.order.daysToRetrieve">
          <small class="form-help">Pedidos que foram atualizados no intervalo de dias configurado irão ser resgatados para o Hub.</small>
        </form-group>
        <order-retrieve-date-configuration :orderConfigs="config.order" :columns="6"/>
      </div>
      <div class="l-row">
        <form-group label="Utilizar rotina específica para novos pedidos">
          <select class="form-select" v-model="config.order.useSpecificCronForNewOrders">
            <option v-for="option in useSpAPIOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
        </form-group>
        <form-group v-if="config.order.useSpecificCronForNewOrders" label="Tempo (em dias) para resgate de novos pedidos criados">
          <input class="form-input" min="1" type="number" v-model="config.order.daysToRetrieveOnlyNewOrders">
          <small class="form-help">Pedidos que foram criados no intervalo de dias configurado irão ser resgatados para o Hub.</small>
        </form-group>
      </div>
      <div class="l-row">
        <form-group label="Webhook notificação de pedidos " :columns="12">
          {{ urlWebhookOrderNotification }}

          <button type="button" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar" v-clipboard:copy="urlWebhookOrderNotification">
            <i class="icon icon-copy2"></i>
          </button>
        </form-group>
      </div>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados na Amazon.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados na Amazon.</small>
        </form-group>

      </div>
    </panel>

  </module-configuration>
</template>

<script>
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'
  import ModalService from '@/components/marketplace/amazon/ModalService'
  import { mapGetters } from 'vuex'
  import cookie from 'vue-cookie'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'amazon'
      }
    },
    data: () => ({
      modalServiceFlag: false,
      errors: [],
      type: 'marketplace',
      identifier: 'amazon',
      config: {
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          daysToRetrieve: 7,
          retrieveDate: null,
          useSpecificCronForNewOrders: false,
          daysToRetrieveOnlyNewOrders: 2
        },
        webhook: {
          sellerId: null
        },
        synchronize: {
          stock: true,
          price: true
        },
        serviceTerms: {
          accepted: false,
          user: null,
          date: null
        }
      },
      synchronizeOptions: [
        true,
        false
      ],
      useSpAPIOptions: [
        false,
        true
      ],
      useSpecificCronForNewOrders: [
        false,
        true
      ]
    }),
    computed: {
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      definitionModule () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'amazon')
      },
      urlWebhookOrderNotification () {
        let url = `https://backend.placemarket.com.br/webhook/marketplace/amazon/order_notification/${cookie.get('merchant')}`

        if (window.location.hostname === 'panel.web') {
          url = `http://backend.app.internal/webhook/marketplace/amazon/order_notification/${cookie.get('merchant')}`
        }

        return url
      }
    },
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration,
      ModalService
    }
  }
</script>

<style scoped>

.terms-link {
  text-decoration: underline;
  cursor: pointer;
}
.inline-text {
  display: inline;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// Amazon.vue?1bc9ab7c